import * as React from "react";

import {
    ClosedStatusBadge,
    OpenStatusBadge,
    PausedStatusBadge,
    PendingStatusBadge,
    RequestedStatusBadge,
} from "../../assets/statusBadges";
import { JobStatus } from "../../domain";

export interface JobStatusLabelProps {
    jobStatus: number | JobStatus;
    id?: string;
    className?: string;
    title?: string;
}

export const JobStatusLabel = (props: JobStatusLabelProps) => {
    const { jobStatus, ...rest } = props;

    const status =
        jobStatus instanceof JobStatus
            ? jobStatus
            : JobStatus.fromId(jobStatus);
    switch (status) {
        case JobStatus.Open:
            return <OpenStatusBadge {...rest} />;
        case JobStatus.Paused:
            return <PausedStatusBadge {...rest} />;
        case JobStatus.Closed:
            return <ClosedStatusBadge {...rest} />;
        case JobStatus.Pending:
            return <PendingStatusBadge {...rest} />;
        case JobStatus.Requested:
            return <RequestedStatusBadge {...rest} />;
        default:
            return null;
    }
};
